import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportBdpGantungPage } from './report-bdp-gantung.page';

const routes: Routes = [
  {
    path: '',
    component: ReportBdpGantungPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportBdpGantungPageRoutingModule {}
